export default __webpack_public_path__ + "static/5-cb12128cbec8c2493de1339e52b60d3d.png";